window.addEventListener('scroll', function() {
  const customMenu = document.querySelector('.custom-scroll-menu');
  const mainMenuHeight = document.querySelector('.main-menu').offsetHeight;
  const customMenuOffset = customMenu.offsetTop;

  if (window.scrollY > customMenuOffset - mainMenuHeight) {
    customMenu.style.position = 'fixed';
    customMenu.style.top = mainMenuHeight + 'px';
    customMenu.style.zIndex = '999';
  } else {
    customMenu.style.position = 'relative';
    customMenu.style.top = 'auto';
  }
});
document.addEventListener('DOMContentLoaded', (event) => {  
  // Find all Request a Quote buttons  
  const requestQuoteButtons = document.querySelectorAll('.request-quote-button');  

  requestQuoteButtons.forEach((button) => {  
    button.addEventListener('click', () => {  
      const productName = document.querySelector('.product-single__title').textContent.trim();  
      openQuoteRequestPopup(productName);  
    });  
  });  

  function openQuoteRequestPopup(productName) {  
    const productQuoteRequest = productName + " quote request";  
  
    Swal.fire({  
      title: 'Request a Quote',  
      html: `  
        <div class="form-vertical test">  
          <form method="post" action="/contact#contact_form" id="contact_form" accept-charset="UTF-8" class="contact-form">  
            <input type="hidden" name="form_type" value="contact">  
            <input type="hidden" name="utf8" value="✓">  
  
            <div class="grid grid--small">  
              <div class="grid__item medium-up--one-whole">  
                <label for="ContactFormName">Name</label>  
                <input type="text" id="ContactFormName" class="input-full" name="contact[name]" autocapitalize="words" value="" required>  
              </div>  
  
              <div class="grid__item medium-up--one-whole">  
                <label for="ContactFormEmail">Email</label>  
                <input type="email" id="ContactFormEmail" class="input-full" name="contact[email]" autocorrect="off" autocapitalize="off" value="" required>  
              </div>  

              <div class="grid__item medium-up--one-whole">  
                <label for="ContactFormMessage">Message</label> 
                <textarea id="ContactFormMessage" class="input-full" name="contact[message]" required></textarea>
              </div>  
            </div>  
  
            <input type="hidden" name="contact[Quote For]" value="${productQuoteRequest}">  
            <button type="submit" class="btn">Send</button>  
          </form>  
        </div>  
      `,  
      showCancelButton: false,  
      showConfirmButton: false,  
      showCloseButton: true,  
      preConfirm: () => {  
        const name = document.getElementById('ContactFormName').value;  
        const email = document.getElementById('ContactFormEmail').value;
        const message = document.getElementById('ContactFormMessage').value;
        const hiddenMessage = document.querySelector('#contact_form input[type="hidden"][name="contact[Quote For]"]').value;  
  
  
        if (!name || !email || !message) {  
          Swal.showValidationMessage('Please fill in all fields.');  
          return false;  
        }  
  
        document.getElementById('ContactFormMessage').value = hiddenMessage + '\n\n';  
  
        return true;  
      }  
  
    }).then((result) => {  
      if (result.isConfirmed) {  
        document.getElementById('contact_form').submit();  
        Swal.fire('Thank you!', 'Your quote request has been submitted.', 'success');  
      }  
    });  
  } 
});